import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { BusinessStatisticItemProps } from './types';

export const BusinessStatisticItem = (props: BusinessStatisticItemProps) => {
    const { displayValue, diffValue, diffDisplay, title } = props;

    return (
        <Flex width="100%" direction="row" justifyContent="space-between" pt={2}>
            <Typography variant="body">{title}</Typography>
            <Flex direction="row" spacing={1} alignItems="baseline">
                {diffValue ? (
                    <Typography
                        variant="caption"
                        color={diffValue >= 0 ? 'var(--color-success)' : 'var(--color-danger)'}
                    >
                        {diffDisplay}
                    </Typography>
                ) : (
                    ''
                )}
                <Typography variant="body">{displayValue}</Typography>
            </Flex>
        </Flex>
    );
};
